import { lazyNamed } from 'src/utils/lazyNamed';

const TagDetails = {
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  DisableRuleList: lazyNamed(() => import('./containers/DisableRuleList'), 'DisableRuleList'),
  DynamicPlacementsList: lazyNamed(() => import('./containers/DynamicPlacementsList'), 'DynamicPlacementsList'),
  PlacementsList: lazyNamed(() => import('./containers/PlacementsList'), 'PlacementsList'),
  Placement: lazyNamed(() => import('./containers/Placement'), 'Placement'),
  BiddersAssign: lazyNamed(() => import('./containers/BiddersAssign'), 'BiddersAssign'),
  RawScriptsList: lazyNamed(() => import('./containers/RawScriptsList'), 'RawScriptsList'),
  FloorRule: lazyNamed(() => import('./containers/FloorRule'), 'FloorRule'),
};

export default TagDetails;
